// extracted by mini-css-extract-plugin
export var divider = "_id-0";
export var systemMessage = "_id-1";
export var systemMessageWrapper = "_id-2";